import React from 'react'
import PropTypes from 'prop-types'
import ComposeExtraButton from './compose_extra_button'

const RichTextEditorButton = ({
  small,
  rte_controls_visible,
  onRichTextToggle
}) => (
  <ComposeExtraButton
    title='Rich Text Editor'
    icon="rich-text"
    onClick={onRichTextToggle}
    small={small}
    active={rte_controls_visible}
    iconClassName={_s.cIconComposeRichText}
  />
)

RichTextEditorButton.propTypes = {
  small: PropTypes.bool,
  onRichTextToggle: PropTypes.func
}

export default RichTextEditorButton